// Marble World (World Labs AI Gaussian-splat worlds) feature switch.
//
// While false, nobody can START a new Marble world: the editor's Add menu shows
// "Marble World · Soon" and explains instead of opening the generator, the
// client service refuses generate/upload calls, and the server route that
// relays Marble uploads (/api/proxy-upload, upload mode) answers 503.
// Worlds that already contain Marble splats keep loading and rendering.
//
// Flip to true to turn generation back on (client + server read this file).
export const MARBLE_ENABLED = false;

export const MARBLE_COMING_SOON_MESSAGE =
  'Marble worlds are coming soon — AI-generated walk-in worlds from a prompt or a photo. Meanwhile, try Studio or Import 3D Environment.';

/** Error code returned by server routes and thrown by the client service. */
export const MARBLE_COMING_SOON_CODE = 'marble_coming_soon';
